import UniqueValueRenderer from '@arcgis/core/renderers/UniqueValueRenderer';
import GeoJSONLayer from "@arcgis/core/layers/GeoJSONLayer";
import RotationVariable from "@arcgis/core/renderers/visualVariables/RotationVariable";
import { dataBarbs } from 'src/constants';

const matchValueWithImage=(windSpeed: number)=>{
    let imgToReturn: any=null;
    dataBarbs.forEach((barb)=>{
        if(windSpeed && windSpeed >= barb.minRange && windSpeed <= barb.maxRange){
            
            imgToReturn= barb.symbol
        }
    })
    return imgToReturn
    
};

const matchValueWithImageVal=(windSpeed: number)=>{
    let imgToReturn: any=null;
    dataBarbs.forEach((barb)=>{
        if(windSpeed && windSpeed >= barb.minRange && windSpeed <= barb.maxRange){
            
            imgToReturn= barb.minRange
        }
    })
    return imgToReturn
    
}
export const formatWindBarbLayer = (data:any[], zoom: number, startDate: any, endDate: any, radio: string)=>{
    const barbGeojson = {
        type: "FeatureCollection",
        features: data.map((item) => ({
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [item.longitude, item.latitude]
            },
            properties: {
                val: radio === 'hourly'? matchValueWithImageVal(Number(item.wind_speed)): matchValueWithImageVal(Number(item.peak_gust_speed_max)),
                symbol: radio === 'hourly'? matchValueWithImage(Number(item.wind_speed)): matchValueWithImage(Number(item.peak_gust_speed_max)),
                rotation: radio === 'hourly'? Number(item.wind_direction) +90: Number(item.peak_wind_gust_direction)+90,
                elevation: item.elevation,
                network: item.network_name,
                state: item.state,
                has_historic_data: (item.has_historic_data).toString().toLowerCase()==='true'?1:0
            }
        }))
    };

    const barbBlob = new Blob([JSON.stringify(barbGeojson)], {
        type: "application/json"
    });
    const barbUrl = URL.createObjectURL(barbBlob);
    const windBarbGeojsonLayer = new GeoJSONLayer({
        url: barbUrl,
        id: `windSpeedBarbs&Zoom=${zoom}&StartDate=${startDate}&EndDate=${endDate}`,
    });
    const valInfos = dataBarbs.map((barb)=>({

        symbol:barb.symbol,
        value: barb.minRange
    }))

    const rotVariable = new RotationVariable({
        field: "rotation",
        rotationType: "geographic"
    })
    const windBarbRenderer = new UniqueValueRenderer({
        field: 'val',
        uniqueValueInfos: valInfos,
        visualVariables: [rotVariable]
    });
    
    windBarbGeojsonLayer.renderer = windBarbRenderer;
    return windBarbGeojsonLayer;

}